module.exports = __webpack_public_path__ + "0fdce550d177db57c89851a6cdce906c.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-25-harrison/diary.jpg
// module id = 980
// module chunks = 0